// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pharmacy-container {
  padding: 1rem 2rem;
  background: #f9fafb;
  font-family: Arial, sans-serif;
  color: #333;
}

/* Adjust heading spacing */
h3 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: #2c3e50;
  border-bottom: 2px solid #2980b9;
  padding-bottom: 0.3rem;
}

/* Add bottom margin between tables */
.pharmacy-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.75rem;
  margin-bottom: 2rem;  /* Space below each table */
}

.pharmacy-table th,
.pharmacy-table td {
  border: 1px solid #ccc;
  padding: 0.6rem 1rem;
  text-align: left;
}

.pharmacy-table thead {
  background-color: #2980b9;
  color: white;
}

.pharmacy-table tbody tr:nth-child(even) {
  background-color: #eaf2f8;
}

.pharmacy-table tbody tr:hover {
  background-color: #d0e4f7;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/Pharmacy.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB,GAAG,2BAA2B;AACnD;;AAEA;;EAEE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".pharmacy-container {\n  padding: 1rem 2rem;\n  background: #f9fafb;\n  font-family: Arial, sans-serif;\n  color: #333;\n}\n\n/* Adjust heading spacing */\nh3 {\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n  color: #2c3e50;\n  border-bottom: 2px solid #2980b9;\n  padding-bottom: 0.3rem;\n}\n\n/* Add bottom margin between tables */\n.pharmacy-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0.75rem;\n  margin-bottom: 2rem;  /* Space below each table */\n}\n\n.pharmacy-table th,\n.pharmacy-table td {\n  border: 1px solid #ccc;\n  padding: 0.6rem 1rem;\n  text-align: left;\n}\n\n.pharmacy-table thead {\n  background-color: #2980b9;\n  color: white;\n}\n\n.pharmacy-table tbody tr:nth-child(even) {\n  background-color: #eaf2f8;\n}\n\n.pharmacy-table tbody tr:hover {\n  background-color: #d0e4f7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
